interface RankItem {
  rank: number;
  title: string;
  category: string;
  hot: string;
  trend: 'up' | 'down' | 'new';
}

const rankings: RankItem[] = [
  {
    rank: 1,
    title: '流浪地球3',
    category: '科幻电影',
    hot: '986万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '长安十二时辰·第二季',
    category: '古装剧集',
    hot: '872万',
    trend: 'new',
  },
  {
    rank: 3,
    title: '奔跑吧·第十二季',
    category: '热门综艺',
    hot: '765万',
    trend: 'up',
  },
  {
    rank: 4,
    title: '凡人修仙传',
    category: '国漫连载',
    hot: '698万',
    trend: 'up',
  },
  {
    rank: 5,
    title: '顶楼',
    category: '韩剧经典',
    hot: '623万',
    trend: 'down',
  },
  {
    rank: 6,
    title: '地球脉动·第三季',
    category: '纪录片',
    hot: '541万',
    trend: 'new',
  },
];

function getTrendIcon(trend: RankItem['trend']) {
  if (trend === 'up') return { icon: 'ri-arrow-up-line', color: 'text-green-500' };
  if (trend === 'down') return { icon: 'ri-arrow-down-line', color: 'text-foreground-400' };
  return { icon: 'ri-flashlight-line', color: 'text-accent-500' };
}

function getRankBadge(rank: number) {
  if (rank === 1) return 'bg-accent-500 text-background-50';
  if (rank === 2) return 'bg-secondary-400 text-background-50';
  if (rank === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-200 text-foreground-500';
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            热度排行
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时热度排名，发现大家都在看什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankings.map((item) => {
            const { icon, color } = getTrendIcon(item.trend);
            return (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-50 transition-colors border-b border-background-200/60 last:border-b-0 cursor-pointer group"
              >
                <div
                  className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${getRankBadge(
                    item.rank
                  )}`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </span>
                    {item.trend === 'new' && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                        NEW
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{item.category}</span>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="flex items-center gap-1">
                    <i className={`${icon} ${color} text-xs`}></i>
                    <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">
                      {item.hot}
                    </span>
                  </div>
                  <div className="w-16 h-1.5 rounded-full bg-background-200 overflow-hidden hidden sm:block">
                    <div
                      className="h-full rounded-full bg-primary-400"
                      style={{ width: `${100 - item.rank * 8}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}